import { isEqual } from "es-toolkit";

import { useAssetUrl } from "@skilitics/assets";

import type { MediaAssetValue } from "../controls/index.ts";

export const useMediaAssetSrc = (config?: MediaAssetValue) =>
  useAssetUrl(config?.source === "file" ? config.assetId : undefined) ??
  (config?.source === "url" ? config.url : undefined);

export const mediaAssetHasChanged = (asset?: MediaAssetValue, newAsset?: MediaAssetValue) => !isEqual(asset, newAsset);
